import { RUN_COMMAND_TOOL_NAME } from '@terra/shared-dto-chat-types';
import type { TerminalExecuteRunCommand } from './portal-terminal-foreground-run';
import { portalToolRegistry } from './portal-tool-registry';
import { buildPortalToolErrorResult } from './types';

export const runPortalTerminalCommand: TerminalExecuteRunCommand = async ({
  sessionId,
  batchId,
  toolCallId,
  input,
}) => {
  const toolName =
    typeof input.toolName === 'string' ? input.toolName : RUN_COMMAND_TOOL_NAME;
  const handler = portalToolRegistry.getHandler(toolName);

  if (!handler) {
    return buildPortalToolErrorResult({
      toolName,
      toolCallId,
      batchId,
      message: `No portal handler registered for ${toolName}`,
    });
  }

  return handler({
    input,
    toolCallId,
    batchId,
    applicationId: sessionId,
    sessionId,
  });
};
